import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerComponent from 'components/Divider/Divider';
import useUnregisterVehicle from 'hooks/vehicles/unregister/useUnregisterVehicle';
import useUnregisterVehicles from 'hooks/vehicles/unregister/useUnregisterVehicles';
import ChooseVehicle from './ChooseVehicle/ChooseVehicle';
import ChooseTagOption from './TagOptions/ChooseTagOption';
import UnregisterVehicleLayout from './UnregisterVehicleLayout';
export default function UnregisterVehicle() {
  const {
    t
  } = useTranslation();
  const {
    currentVehicle,
    currentTagOption,
    validVehicle
  } = useUnregisterVehicle();
  const {
    isLoading,
    unregisterVehiclesFunction
  } = useUnregisterVehicles();
  const handleOnSubmit = () => {
    if (!currentVehicle?.id) return;
    const vehicle = {
      ...currentVehicle,
      tagOption: currentTagOption
    };
    unregisterVehiclesFunction([vehicle]);
  };
  return /*#__PURE__*/React.createElement(UnregisterVehicleLayout, {
    onForwardButtonClick: handleOnSubmit,
    hasForwardButtonDisabled: isLoading || !validVehicle,
    isForwardButtonLoading: isLoading,
    isFinalStep: true,
    altForwardButtonText: t('buttons.remove_chosen')
  }, /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseVehicle, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseTagOption, null));
}